import { defineComponent as p, computed as u } from "vue";
import d from "./component-library3.js";
import s from "./component-library81.js";
const g = /* @__PURE__ */ p({
  __name: "energy-label-datasheet",
  props: {
    label: { type: String, default: "Produktdatenblatt" },
    labelColor: { type: String, default: "" },
    products: {
      type: Array,
      required: !0
    },
    alignDropdown: {
      type: String,
      default: "right",
      validator(n) {
        return ["right", "left", "justify"].includes(n);
      }
    },
    isInternalLink: { type: Boolean }
  },
  emits: ["open-document"],
  setup(n, { expose: i, emit: r }) {
    const e = n, o = u(() => e.products ? e.products.filter((t) => !!t.documentPath).map(
      (t) => ({
        value: t.documentPath,
        label: t.name
      })
    ) : []), l = u(
      () => o.value.length === 1 ? o.value[0] : void 0
    ), a = (t) => {
      if (t) {
        if (e.isInternalLink) {
          r("open-document", t);
          return;
        }
        window.open(t, "_blank");
      }
    };
    return i({
      openNewTab: a
    }), { __sfc: !0, props: e, emit: r, energyDocumentList: o, singleItem: l, openNewTab: a, LinkButton: d, ListDropdown: s };
  }
});
export {
  g as default
};
